var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup25208(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_2",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25208",
    "data-name": "Group 25208",
    transform: "translate(-921 -556)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 921, 556)",
    filter: "url(#Ellipse_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(15 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "google-seeklogo.com",
    transform: "translate(941.971 573.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M137.5,108.241a6.2,6.2,0,0,0-.153-1.48h-6.8v2.686h3.99a3.538,3.538,0,0,1-1.48,2.349l-.014.09,2.149,1.665.149.015a7.078,7.078,0,0,0,2.156-5.325",
    transform: "translate(-123.44 -100.973)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M20.392,162.177a6.9,6.9,0,0,0,4.794-1.753l-2.284-1.77a4.284,4.284,0,0,1-2.51.724,4.358,4.358,0,0,1-4.118-3.008l-.085.007-2.235,1.729-.029.081a7.234,7.234,0,0,0,6.467,3.99",
    transform: "translate(-13.153 -147.831)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M3.121,76.029A4.457,4.457,0,0,1,2.88,74.6a4.683,4.683,0,0,1,.233-1.432l0-.1L.846,71.312l-.074.035a7.224,7.224,0,0,0,0,6.5l2.349-1.818",
    transform: "translate(0 -67.423)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M20.318,2.8a3.943,3.943,0,0,1,2.767,1.078l2.02-1.995A6.833,6.833,0,0,0,20.318,0a7.144,7.144,0,0,0-6.393,3.99l2.314,1.818A4.331,4.331,0,0,1,20.318,2.8",
    transform: "translate(-13.153)",
    fill: "#eb4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25208);
export default __webpack_public_path__ + "static/media/Group25208.3b845ad283e9caad7d9221bdb6ad69bf.svg";
export { ForwardRef as ReactComponent };